import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    // E57 · D-nav-fixes-2026-10-19 (Q-nav-7 B): the bar is 48 px everywhere — its controls are centred in one 48 px row
    // (no top margins); a running session adds its own second row below
    'header': {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      height: 'auto',
      minHeight: 48,
    },
    'header-filter-client': {
      'display': 'flex',
      'flexDirection': 'row',
      'flexWrap': 'wrap',
      'alignItems': 'center',
      '@media screen and (max-width: 550px)': {
        justifyContent: 'center',
      },
    },
    'header-filter-client--select': {
      'minWidth': 120,
      'width': 240,
      'marginRight': 10,
      '@media screen and (max-width: 550px)': {
        marginBottom: 10,
      },
    },
    'header-filter-client--label': {
      marginRight: '10px',
      fontWeight: 600,
    },
    'header-filter-client--tooltip': {
      margin: '0 20px 0 10px',
    },
    'header-language-selector': {
      marginLeft: 'auto',
    },
    'header-main-row': {
      'display': 'flex',
      'flexDirection': 'row',

      'flexWrap': 'wrap',
      'alignItems': 'center',
      'justifyContent': 'space-between',
      'gap': 8,
      'minHeight': 48,
      'height': 'auto',
      '@media screen and (max-width: 655px)': {
        flexDirection: 'column-reverse',
      },
    },
    'header-divider': {
      margin: '0 0 10px 0',
    },
    'header-session-row': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginBottom: '10px',
    },
    'header-session-row--item': {
      marginRight: '10px',
      marginBottom: '0',
    },
    'header-session-button': {
      marginLeft: 8,
    },
  };
});
export default useStyles;
